export interface FontMetadata {
    format: string;
    path: string;
}

export interface CreateFontFaceCSSProps {
    name: string;
    baseUrl: string;
    paths: FontMetadata[];
    fontDisplay?: 'auto' | 'block' | 'swap' | 'fallback' | 'optional';
}

export const getUrls =
    (baseUrl: string) =>
    ({ format, path }: FontMetadata) =>
        `url('${baseUrl}${path}') format('${format}')`;
export const getSrc = (baseUrl: string) => (fontsMetadata: FontMetadata[]) =>
    fontsMetadata.map(getUrls(baseUrl)).join(', ');

export const createFontFaceCSS = ({ name, baseUrl, paths, fontDisplay }: CreateFontFaceCSSProps) => `
    @font-face {
        font-family: '${name}';
        src: ${getSrc(baseUrl)(paths)};
        ${fontDisplay && `font-display: ${fontDisplay};`}
    }
`;
